import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Companies() {
  const [companies, setCompanies] = useState([]);
  useEffect(() => { api.get("/companies").then((r) => setCompanies(r.data || [])).catch(() => {}); }, []);
  return (
    <div className="max-w-[1280px] mx-auto px-4 sm:px-6 py-10">
      <div className="border-b-2 border-ink pb-3 mb-8">
        <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-crimson">The Fin Desk</div>
        <h1 className="font-serif font-bold text-4xl sm:text-5xl text-ink mt-1">Companies</h1>
        <p className="text-ink2 mt-2 max-w-2xl">Profiles of the banks, EMIs, payment institutions, fintechs, processors and infrastructure providers shaping modern finance.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {companies.map((c) => (
          <Link key={c.id} to={`/companies/${c.slug}`} data-testid={`company-card-${c.slug}`}
            className="border border-hair p-6 hover:border-crimson transition-colors group bg-surface">
            <div className="flex items-start justify-between">
              <h2 className="font-serif text-2xl text-ink group-hover:text-crimson transition-colors">{c.name}</h2>
            </div>
            <div className="text-xs uppercase tracking-widest text-crimson font-bold mt-1">{c.company_type}</div>
            <div className="text-xs text-mutedink mt-0.5">{c.country}</div>
            <p className="text-sm text-ink2 mt-3 line-clamp-3 leading-relaxed">{c.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
